// Sliders
import './sliders';

// News details script
import './_news-details.js';